import { store } from '../../store'
import { http, httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({ commit, dispatch }, payload) {
    let url = 'api/notifications/all/' + payload.event.application_id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  lastestNotView ({ commit, dispatch }, payload) {
    let url = 'api/notifications/latest-not-view/' + payload.event.application_id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLatestNotView', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getUnread ({ commit, dispatch }, payload) {
    let url = 'api/notification/' + store.state.userLogged.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetUnread', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put ({ commit, dispatch }, payload) {
    let url = 'api/notifications/' + payload.event.item.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, {}, options)
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete ({ commit, dispatch }, payload) {
    let url = 'api/notifications/' + payload.event.item.id
    http.defaults.headers.common['Autorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  onGet (state, payload) {
    let notifications = payload.response.data.data
    payload.event.context.notifications = notifications
    payload.event.context.loadingItems = false
  },
  onGetLatestNotView (state, payload) {
    let notifications = payload.response.data.data.notifications
    let total = payload.response.data.data.total
    store.state.notificationsState = notifications
    store.state.totalNotView = total
  },
  onGetUnread (state, payload) {
    let notifications = payload.response.data.data
    store.state.notificationsState = notifications.reverse()
  },
  onPut (state, payload) {
    // payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refresh()
  },
  onDelete (state, payload) {
    payload.event.context.refresh()
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js